import React from "react"
import Delimiter from "../../images/curve.png"
import DelimiterNoSpace from "../../images/delimiter_no_space.png"
import "./index.scss"
import LoaderMobile from "../../loader/loader_mobile.mp4"

export const ImageHeader = ({ imgSrc, noSpace, resize, videoSrc }) => {
  return <div>
    <div className="app-image-header-wrapper">
      {noSpace &&
      <div className="text-center">
        {!videoSrc &&
        <img className={"img-fluid app-header-image " + (resize ? "resize" : "")} src={imgSrc}/>
        }
        {videoSrc &&
        <video autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "100%", objectFit: "cover" }}
               src={videoSrc}/>
        }
        <div className={"app-image-header-delimiter " + (noSpace ? "img-no-space" : "")}
             style={{ backgroundImage: noSpace ? `url('${DelimiterNoSpace}')` : `url('${Delimiter}')` }}/>
      </div>
      }
      {!noSpace &&
      <div>
        {!videoSrc &&
        <div className={"app-image-header-container " + (noSpace ? "img-no-space" : resize ? "resize" : "")}
             style={{ backgroundImage: `url('${imgSrc}')` }}/>
        }
        {videoSrc &&
        <video className="header-video" autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "100%", objectFit: "cover" }}
               src={videoSrc}/>
        }
        <div className={"app-image-header-delimiter " + (noSpace ? "img-no-space" : "")}
             style={{ backgroundImage: noSpace ? `url('${DelimiterNoSpace}')` : `url('${Delimiter}')` }}/>
      </div>
      }
    </div>
  </div>
}
